<template>
  <div>
    <form @submit.prevent="submitForm" class="ui-form" method="POST" ref="presignup">
      <div class="row signup__columns mt-md-4 mt-0">
        <div class="col-lg-12 col-md-6 col-12" data-wronged="">
          <div class="signup__input-wrapper">
            <input
              type="text"
              id="name"
              v-model="form.name"
              maxlength="255"
              required
              autocomplete="off"
            />
            <label for="name"> Nome Completo* </label>
          </div>
        </div>
        <div class="col-lg-12 col-md-6 col-12" data-wronged="">
          <div class="signup__input-wrapper">
            <input
              type="email"
              id="email-signup"
              @blur="checkEmail($event)"
              v-model="form.email"
              maxlength="255"
              required
              autocomplete="off"
            />
            <label for="email-signup"> E-mail* </label>
          </div>
        </div>
        <div class="col-lg-12 col-md-6 col-12" data-wronged="">
          <div class="signup__input-wrapper">
            <input
              type="password"
              id="password-signup"
              v-model="form.password"
              minlength="6"
              maxlength="20"
              required
              autocomplete="off"
            />
            <label for="password-signup"> Senha* </label>
          </div>
        </div>
        <div class="col-xl-6 col-lg-12 col-md-6 col-12" data-wronged="">
          <label for="pf" class="signup__radio">
            <input
              type="radio"
              id="pf"
              name="pfpj"
              value="pf"
              v-model="form.person_type"
              @click="changePersonType('pf')"
            />
            <span></span>
            Pessoa Física
          </label>
        </div>
        <div class="col-xl-6 col-lg-12 col-md-6 col-12" data-wronged="">
          <label for="pj" class="signup__radio">
            <input
              type="radio"
              id="pj"
              name="pfpj"
              value="pj"
              v-model="form.person_type"
              @click="changePersonType('pj')"
            />
            <span></span>
            Pessoa Jurídica
          </label>
        </div>
      </div>
      <div class="row signup__columns d-flex justify-content-center">
        <div class="col-md-6 col-12 d-flex flex-column align-items-center mb-0">
          <button
            type="submit"
            class="ui-button--verde w-md-50 w-100 signup__submit mb-0"
            :disabled="block == true"
          >
            {{ button }}
          </button>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import axios from 'axios'
import LogHelper from './Helpers/LogHelper'

export default {
  props: ['register_endpoint', 'check_email_endpoint', 'login_endpoint', 'home_endpoint', 'is_app'],
  data() {
    return {
      form: {
        name: '',
        email: '',
        password: '',
        person_type: 'pf',
      },
      button: 'CONTINUAR COMPRA',
      disabled: false,
      block: false,
      is_email_ok: true,
    }
  },
  watch: {
    'form.person_type': function () {
      this.removeErrorMessages()
    },
  },
  methods: {
    changePersonType(type) {
      this.form.person_type = type
    },
    resetForm() {
      this.form = {
        name: '',
        email: '',
        password: '',
        person_type: this.form.person_type,
      }
    },
    removeErrorMessages() {
      //Removes all error messages from the inputs
      var items = this.$refs.presignup.querySelectorAll('.ui-wronged')
      for (var i = items.length - 1; i >= 0; i--) {
        if (items[items.length - 1].children[0].id == 'email-signup') {
          continue
        }
        items[items.length - 1].classList.remove('ui-wronged')
      }
    },
    async checkEmail(email) {
      this.$refs.presignup.querySelector('.signup__submit').disabled = true
      if (this.form.email) {
        await axios
          .post(this.check_email_endpoint, { email: this.form.email })
          .then((response) => {
            if (response.data.name) {
              this.$refs.presignup
                .querySelector('#email-signup')
                .parentElement.classList.remove('ui-correct')
              this.assignError(
                this.$refs.presignup.querySelector('#email-signup'),
                'Já há uma conta com este e-mail!'
              )
              this.is_email_ok = false
              this.$refs.presignup.querySelector('.signup__submit').removeAttribute('disabled')
            } else if (response.data == '') {
              this.$refs.presignup
                .querySelector('#email-signup')
                .parentElement.classList.remove('ui-wronged')
              this.assignSuccess(
                this.$refs.presignup.querySelector('#email-signup'),
                'Este e-mail é válido :)'
              )
              this.is_email_ok = true
              this.$refs.presignup.querySelector('.signup__submit').removeAttribute('disabled')
            }
          })
          .catch((e) => {
            let message = ''
            this.$refs.presignup
              .querySelector('#email-signup')
              .parentElement.classList.remove('ui-correct')
            if (e.response.data.errors.email[0] == 'validation.unique') {
              message = 'Já há uma conta com este e-mail!'
            } else if (e.response.data.errors.email[0] == 'validation.required') {
              message = 'É necessário preencher um e-mail!'
            } else if (
              e.response.data.errors.email[0] == 'validation.email' ||
              e.response.data.errors.email[0] == 'validation.regex'
            ) {
              message = 'Preencha com um e-mail válido!'
            }
            let item = this.$refs.presignup.querySelector('#email-signup')
            this.assignError(item, message)
            this.$refs.presignup.querySelector('.signup__submit').removeAttribute('disabled')
            LogHelper.sendLogToGoogleChat(`Formulário de cadastro | ${message}`, 406)
            this.is_email_ok = false
          })
      } else {
        this.$refs.presignup.querySelector('.signup__submit').removeAttribute('disabled')
      }
    },
    async submitForm() {
      this.$refs.presignup.querySelector('.signup__submit').disabled = true
      let is_form_ok = await this.isFormOk()
      if (is_form_ok && this.is_email_ok) {
        this.$refs.presignup
          .querySelector('#email-signup')
          .parentElement.classList.remove('ui-correct')
        this.$refs.presignup.querySelector('.signup__submit').disabled = true
        this.removeErrorMessages()
        const sleepingPromise = (delay) => new Promise((resolve) => setTimeout(resolve, delay))
        const sleep = async () => {
          await sleepingPromise(1000)
          window.scrollTo(0, 0)
          // this.$refs.presignup.querySelector('#signup-change').innerHTML =
          //   'Olá, <strong>' + this.form.name + '</strong>, somente precisamos de mais alguns dados.'
          // this.$refs.presignup.querySelector('#signup-change').classList.add('blink')
          this.$emit('preSignedUp', this.form)
          this.$refs.presignup.querySelector('.signup__submit').removeAttribute('disabled')
        }
        sleep()
      } else {
        this.$swal({
          title: 'Oops :|',
          text: 'Tivemos um pequeno problema. Por favor, verifique os campos do formulário.',
          showCancelButton: false,
          confirmButtonText: 'Ok',
          confirmButtonColor: '#6fe335',
        })

        this.button = 'CONTINUAR COMPRA'
        this.$refs.presignup.querySelector('.signup__submit').removeAttribute('disabled')
      }
    },
    async isFormOk() {
      this.removeErrorMessages()
      var is_ok = true

      //Checks if the name has more than two words if it's a PF
      var name = this.$refs.presignup.querySelector('#name')
      if (this.form.person_type == 'pf' && !(name.value.indexOf(' ') >= 0)) {
        const message = 'Digite nome e sobrenome, por favor'
        this.assignError(name, message)
        is_ok = false
        LogHelper.sendLogToGoogleChat(`Formulário de cadastro | ${message}`, 406)
      }

      //Checks if the password has at least 6 digits
      const password = this.$refs.presignup.querySelector('#password-signup')
      if (password.value.length < 6) {
        const message = 'A senha precisa ter 6 caracteres, no mínimo'
        this.assignError(password, message)
        is_ok = false
        LogHelper.sendLogToGoogleChat(`Formulário de cadastro | ${message}`, 406)
      }

      // Checks if all basic fields are fielled
      var items = ['name', 'email-signup', 'password-signup']
      for (var i = 0; i < items.length; i++) {
        var element = this.$refs.presignup.querySelector(`#${items[i]}`)
        if (element.value.length < 1) {
          const message = 'Este campo é obrigatório'
          this.assignError(element, message)
          is_ok = false
          LogHelper.sendLogToGoogleChat(`Formulário de cadastro (${items[i]}) | ${message}`, 406)
        }
      }

      this.$refs.presignup.querySelector('.signup__submit').removeAttribute('disabled')
      return is_ok
    },
    assignError(element, message) {
      //Assign an error message
      element.parentElement.dataset.wronged = message
      element.parentElement.classList.add('ui-wronged')
    },
    assignSuccess(element, message) {
      //Assign a success message
      element.parentElement.dataset.wronged = message
      element.parentElement.classList.add('ui-correct')
    },
  },
}
</script>
